import { render, staticRenderFns } from "./CommercialClaimTransferModal.vue?vue&type=template&id=7e7c3090&lang=html&"
import script from "./CommercialClaimTransferModal.vue?vue&type=script&lang=js&"
export * from "./CommercialClaimTransferModal.vue?vue&type=script&lang=js&"
import style0 from "./CommercialClaimTransferModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports